import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

const CONTAINER_WIDTH = 826;

export const styles: StyleRulesCallback = ({ breakpoints, spacing: { unit } }) => {
  const selectorOverflowPadding = unit * 3;
  return {
    hero: {
      overflow: "visible"
    },
    selectorContainerPadding: {
      [breakpoints.down(CONTAINER_WIDTH)]: {
        paddingBottom: `${selectorOverflowPadding}px`
      }
    }
  };
};

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
